export default __webpack_public_path__ + "static/media/intro_image_3.ae7f9e2e.jpg";